import React, { useRef, useEffect } from "react";
import styles from "./SelectionVisualizer.module.scss";
import wrapStyles from "../CustomWraps.module.scss";

import {useSelector} from "react-redux";
import {gsap} from "gsap";
import PhotoChooser from "components/homePanels/l_customWraps/selectionVisualizer/photoChooser/PhotoChooser";
import SelectionsForm from "components/homePanels/l_customWraps/selectionVisualizer/selectionsForm/SelectionsForm";
import SwatchGallery from "components/homePanels/l_customWraps/selectionVisualizer/swatchGallery/SwatchGallery";

const SelectionVisualizer = (props) => {

    const wrapSelection = useSelector(state => state.wrapSelection);
    const prevSelections = useRef(wrapSelection);
    const visualizer = useRef();
    const title = useRef();
    const ddAction = useRef(false)

    useEffect(()=>{
        setTimeout(()=>{

            if(!ddAction.current && wrapSelection.product && wrapSelection.design && prevSelections.current !== wrapSelection){

                let top = visualizer.current.offsetTop + visualizer.current.parentNode.offsetTop

                if(visualizer.current) gsap.to(props.scrollNode.current, {delay: 0, duration: 2, scrollTo: top, onComplete: ()=>{
                        title.current.focus();
                    }
                });

                ddAction.current = true;
                prevSelections.current = wrapSelection;
            }
             ddAction.current = false;
        }, 100)
    }, [wrapSelection, props.scrollNode])



    return !(wrapSelection.product && wrapSelection.design) ?  <></> : (
        <>
            <div ref={visualizer} className={`${wrapStyles.wrapsBlade} ${styles.visualizer}`}>
                <h4 tabIndex={-1} ref={title}>Make it yours with <img className={styles.dbrand} src={'https://msobd-storage.azureedge.net/images/customWraps/dbrand-logo.png'} alt={'dbrand logo'}/></h4>
                <div className={styles.productMain}>
                    <PhotoChooser/>
                    <SelectionsForm ddAction={()=> {ddAction.current = true}}/>
                </div>

                <SwatchGallery ddAction={()=> {ddAction.current = true}}/>

            </div>

        </>
    )
};

export default SelectionVisualizer;
